import MainContent from "../../components/MainContent/MainContent";
import About from "../../components/About/About";
import Work from "../../components/Work/Work";
import WorkFormat from "../../components/WorkFormat/WorkFormat";
import Appointment from "../../components/Appointment/Appointment";

const MainPage = () => (
    <>
        <MainContent />
        <About />
        <Work />
        <WorkFormat />
        <Appointment />
    </>
);

export default MainPage;
